import React from 'react'

import './styles/cpop-signup.css'

import { CrumplePopSignupProvider } from './contexts/CrumplePopSignupContext'
import CrumplePopMigration from './components/CrumplePopMigration'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { ToastContainer } from 'react-toastify'

export default function App() {
    const queryClient = new QueryClient();

    return (
        <CrumplePopSignupProvider>
            <QueryClientProvider client={queryClient}>
                <div className='cpop-migration-container'>
                    <CrumplePopMigration />
                </div>
            </QueryClientProvider>
            <ToastContainer />
        </CrumplePopSignupProvider>
    )
}
